import MUIButton, { ButtonProps } from '@mui/material/Button';

export const Button = ({ children, ...props }: ButtonProps): JSX.Element => {
  return <MUIButton {...props}>{children}</MUIButton>;
};
